<template>
  <b-form>
    <b-row>
      <b-col
        v-for="(field, index) in form_fields"
        :key="index"
        :cols="field.col_size || 12"
      >
        <b-form-group>
          <label
            class="d-block"
            :for="`field-${field.label}`"
          >{{ field.label || ' ' }}</label>
          <validation-provider
            #default="{ errors }"
            :name="field.label"
            :rules="field.validation_rules"
          >
            <component
              :is="field.component_name || 'b-form-input'"
              :id="`field-${index}-${field.label}`"
              v-model="form_obj[field.obj_name]"
              v-bind="field.props"
              :state="errors.length > 0 ? false : null"
              :placeholder="field.placeholder"
              @input="$emit('field_update', form_obj)"
            >
              {{ field.content_text }}
            </component>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import {
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BFormRadioGroup,
  BFormTextarea,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormRadio,
  BFormFile,
} from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { required, length, email } from '@validations'
import Cleave from 'vue-cleave-component'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    vSelect,
    BRow,
    BCol,
    flatPickr,
    BFormRadioGroup,
    BFormTextarea,
    BFormCheckbox,
    BFormRadio,
    BFormCheckboxGroup,
    BFormFile,
    Cleave,
  },
  props: {
    form_fields: {
      type: Array,
      required: true,
    },
    def_form_obj: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      length,
      email,
      form_obj: {},
    }
  },
  watch: {
    def_form_obj() {
      this.form_obj = this.def_form_obj
      console.log('update')
      this.$forceUpdate()
    },
  },
  mounted() {
    if (this.def_form_obj) {
      this.form_obj = this.def_form_obj
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';

</style>
